import type { AxiosError } from 'axios'

type ErrorLike = {
  message?: string
}

export function normalizeTenantApiSegment(value: string | number): string {
  const normalized = String(value).trim()
  if (!normalized || normalized.includes('/') || normalized.includes('\\') || /[\u0000-\u001F\u007F]/.test(normalized)) {
    throw new Error('非法学校（租户）接口路径段')
  }
  return encodeURIComponent(normalized)
}

export function buildTenantApiPath(tenantSlug: string, ...segments: Array<string | number | undefined | null>): string {
  const normalizedTenant = normalizeTenantApiSegment(tenantSlug)
  const path = segments
    .filter((segment): segment is string | number => segment !== undefined && segment !== null && String(segment).trim() !== '')
    .map((segment) => normalizeTenantApiSegment(segment))
    .join('/')

  return '/api/v1/tenant/' + normalizedTenant + (path ? '/' + path : '')
}

export function buildTenantLoginMetaPath(tenantSlug: string): string {
  return '/api/v1/tenant/login-meta/' + normalizeTenantApiSegment(tenantSlug)
}

export function resolveApiError(error: unknown, fallback: string): string {
  const axiosError = error as AxiosError<ErrorLike>
  const status = axiosError?.response?.status
  const payload = axiosError?.response?.data

  if (status === 403) {
    if (payload && typeof payload.message === 'string' && payload.message.trim().length > 0) {
      return payload.message
    }
    return '应用尚未开通或暂无权限访问'
  }

  if (status === 404) {
    return '目标数据暂未开启或不存在'
  }

  if (payload && typeof payload.message === 'string' && payload.message.trim().length > 0) {
    return payload.message
  }

  if (axiosError?.message) {
    return axiosError.message
  }

  return fallback
}

export function extractPaginationResult<T>(response: any): { items: T[]; total: number } {
  const arrayData = Array.isArray(response?.data) ? response.data : []
  const meta = response?.meta ?? {}
  const totalCandidate = meta.total ?? response?.total
  const total = typeof totalCandidate === 'number' ? totalCandidate : arrayData.length

  return { items: arrayData as T[], total }
}
